<li
  on:keydown={handleMenuNavigation}
>
  <button
    linkButton
    bind:this={button}
    on:click|stopPropagation={() => (open = !open) }
    class={colorClassNames.primary}
    aria-expanded={open}
    aria-controls="profileMenu"
  >
    {#if user}
      <UserIcon {...user} />
    {/if}
    <div class="mh-profile-title">
      <span>{text}</span>
      <Chevron direction={open ? 'up' : 'down'} />
    </div>
  </button>

  <div id="profileMenu" class="mh-dropdown-menu" class:mh-open={open}>
    <ProfileDropdownMenu bind:this={menu} {items} />
  </div>
</li>

<svelte:window on:click={() => (open = false) } />

<style lang="less">
  @import (reference) '../../../less/variables';

  li {
    display: flex;
    position: relative;

    /*
     * The additional styles below
     * override encore-web global
     * styles
     */
    font-size: @masthead-font-size-medium;
    line-height: inherit;
    letter-spacing: 0;
  }

  button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    margin-left: 7px;
    padding: 20px 0;
    text-decoration: none;
    font: inherit;
    font-weight: @masthead-font-weight-bold;
    outline: none;
    cursor: pointer;
  }

  button:hover,
  button:focus {
    color: currentColor;
  }

  div.mh-profile-title {
    display: inline-block;
    margin: auto 0;
  }

  span {
    display: inline-block;
    margin: auto 0 auto 10px;
  }

  div.mh-dropdown-menu {
    display: none;
  }

  div.mh-dropdown-menu.mh-open {
    display: block;
    position: absolute;
    top: 100%;
    right: -17px;
    margin-top: -8px;
  }

  @media (max-width: @breakpoint-tablet - 1) {
    button {
      display: none;
    }

    div.mh-dropdown-menu,
    div.mh-dropdown-menu.mh-open {
      display: block;
    }
  }
</style>

<script>
  import Chevron from './Chevron.html';
  import UserIcon from './UserIcon.html';
  import ProfileDropdownMenu from './ProfileDropdownMenu.html';
  import breakpoints from '../../../constants/breakpoints.json';

  export let user;
  export let text;
  export let items;
  export let colorClassNames;

  let button;
  let menu;
  let open = false;

  const handleMenuNavigation = event => {
    if (window.innerWidth < breakpoints['breakpoint-tablet']) {
      return;
    }

    const HANDLED_KEYS = ['Escape', 'ArrowDown', 'ArrowUp'];

    if (HANDLED_KEYS.includes(event.key)) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (event.key === 'Escape') {
      open = false;
      button.focus();
    } else if (event.key === 'ArrowDown') {
      open = true;
      menu.selectNext();
    } else if (event.key === 'ArrowUp') {
      open = true;
      menu.selectPrevious();
    }
  };
</script>
